<ul class="no-list-style">
  <li *ngFor="let cat of groupedServices; let first = first" [class.ps-xsmall-t]="!first">
    <div class="flex flex--middle">
      <fcom-icon [name]="cat.icon" class="ir-xsmall ms-xsmall-r"></fcom-icon>
      <div class="font-body-1 medium-type">
        {{ 'MMB.includedProducts.serviceCategory.' + cat.key + '.title' | finLocalization }}
      </div>
    </div>

    <ul class="accommodate-icon list-disc-style">
      <li *ngFor="let service of cat.services">
        {{
          service.includedInTierBenefit
            ? service.displayName
            : ('MMB.includedProducts.' + service.subCategory + '.text'
              | finLocalization
                : {
                    seatNumber: service.seatNumber,
                    amount: service.quantity,
                    weight: service.parameters?.baggageWeight,
                    displayName: service.displayName
                  }
              | finEmpty: service.displayName)
        }}
      </li>
    </ul>
  </li>
</ul>
